module.exports = __webpack_public_path__ + "img/gamesdk17.7a47ad9.png";